import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQuery } from 'src/utils/base-query.js'

export const dfyApi = createApi({
  reducerPath: 'dfyApi',
  baseQuery,
  endpoints: (builder) => ({
    searchDomain: builder.mutation({
      query: (data) => {
        return {
          url: 'dfy-setup/searchDomain/' + data,
          method: 'GET'
        }
      }
    }),
  })
})

export const {
    useSearchDomainMutation
} = dfyApi
